const breakpoints = {
  sm: '415px',
  md: '768px',
  lg: '1000px',
  xl: '1440px',
  '2xl': '1920px',
  '3xl': '3000px',
};

export default breakpoints;
